import PropTypes from 'prop-types'
import { CustomCheckbox } from '../elements/checkbox'

export default function RadioCard({
  value,
  active,
  disabled,
  onChange,
  children,
  tight,
}) {
  return (
    <div className={!tight ? 'tw-mb-5' : null}>
      <div
        className={`
          tw-relative
          tw-rounded 
          tw-shadow
          tw-border-2
          tw-border-solid
          ${
            active
              ? `${
                  disabled ? 'tw-border-system-grey-300' : 'tw-border-primary'
                }`
              : 'tw-border-system-grey-300'
          }
          ${!disabled && 'hover:tw-border-primary'}
    `}>
        <div
          className={`tw-flex tw-absolute tw-right-0 tw-transition-all tw-ease-in-out tw-duration-300 ${
            active ? 'tw-opacity-1' : 'tw-opacity-0'
          }`}>
          <CustomCheckbox
            active={active}
            disabled={disabled}
            hidden={!active}
          />
        </div>
        <label
          htmlFor={value}
          className={`tw-block ${
            !disabled ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed'
          }`}>
          <input
            type="radio"
            id={value}
            name="radio-card"
            className="tw-absolute tw-opacity-0"
            value={value}
            defaultChecked={!!active}
            disabled={!!disabled}
            onChange={() => onChange(value)}
          />
          <div className="tw-p-5">{children}</div>
        </label>
      </div>
    </div>
  )
}

RadioCard.propTypes = {
  disabled: PropTypes.any,
  active: PropTypes.any,
  onChange: PropTypes.func,
  value: PropTypes.any,
  tight: PropTypes.bool,
  children: PropTypes.node,
}
